import React from 'react';
import './componenetStyle/TowaryUslugi.css';
import ListaTowarowUslug from './TowaryUslugi/ListaTowarowUslug';


function TowaryUslugi() {
    return (
        <div>
            

            <ListaTowarowUslug />

        </div>
    );
}

export default TowaryUslugi;